export enum TypeModification {
  NAME = '1',
  ADDRESS = '2',
  PATRIMONY = '3',
  OBJECT = '4'
}

export const TYPE_MODIFICATIONS = {
  NAME: '1',
  ADDRESS: '2',
  PATRIMONY: '3',
  OBJECT: '4'
} as const

export const NAME_MODIFICATIONS = {
  1: 'Nombre',
  2: 'Domicilio',
  3: 'Patrimonio (capital)',
  4: 'Objeto'
} as const

export const KEYS_FEIC_SIB = {
  1: 1,
  2: 1,
  3: 2,
  4: 3
}

export const CATALOG_TYPE_MODIFICATIONS = [
  {
    value: TYPE_MODIFICATIONS.NAME,
    label: NAME_MODIFICATIONS[1]
  },
  {
    value: TYPE_MODIFICATIONS.ADDRESS,
    label: NAME_MODIFICATIONS[2]
  },
  {
    value: TYPE_MODIFICATIONS.PATRIMONY,
    label: NAME_MODIFICATIONS[3]
  },
  {
    value: TYPE_MODIFICATIONS.OBJECT,
    label: NAME_MODIFICATIONS[4]
  }
]
